






import { lecturas_codigo_barras } from "@/shared/dtos/lecturas_codigo_barras";
import lecturas_codigo_barrasModule from "@/store/modules/lecturas_codigo_barras-module";
import { Component, Vue } from "vue-property-decorator";
import qrcodeScannerVue from "./qrcode-scanner.vue";
@Component({
  components: { qrcodeScannerVue },
})
export default class LectorCodigos extends Vue {
  public decodeBarcode = "";

  onScan(decodedText: string, decodedResult: string) {
    // handle the message here :)
    if (this.decodeBarcode !== decodedText) {
      var codigo = new lecturas_codigo_barras();
      codigo.referencia =decodedText;
      codigo.dispositivo = this.obtenerNombreDispositivo();
      lecturas_codigo_barrasModule.guardarlecturas_codigo_barras(codigo);
    }
    this.decodeBarcode = decodedText;
  }

  obtenerNombreDispositivo(): string {
    const userAgent = navigator.userAgent.toLowerCase();

    // Ejemplo básico para detectar sistemas operativos y navegadores
    if (/iphone/i.test(userAgent)) {
      return "iPhone";
    } else if (/ipad/i.test(userAgent)) {
      return "iPad";
    } else if (/android/i.test(userAgent)) {
      const androidModel = userAgent.match(
        /android\s([0-9\.]*)\s;\s([^\)]+)\)/
      );
      return androidModel ? `Android (${androidModel[2]})` : "Android";
    } else if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    } else if (/macintosh/i.test(userAgent)) {
      return "Mac";
    } else if (/windows/i.test(userAgent)) {
      return "Windows PC";
    } else if (/linux/i.test(userAgent)) {
      return "Linux";
    } else if (/blackberry/i.test(userAgent)) {
      return "BlackBerry";
    } else {
      return "Dispositivo desconocido";
    }
  }
}
